export default "__VITE_ASSET__BmsjQYRh__"